export class EventRepeater {

	constructor(repeatCount:number, startDelay:number, delay:number, fn:Function){
		this._startDelay = startDelay;
		this._repeatCount = repeatCount
		this._delay = delay;
		this._fn = fn;
	}

	public start(){
		this.reset();
		this._count = 0;
		this._startId = setTimeout(() => {
			this.tick();
			this._startId = -1;
		 }, this._startDelay);
	}

	public cancel(){ this.reset(); }
	public isDone(){ return this._tickId !== null; }
	public getIndex(){ return this._count; }

	private _startId:any = -1;
	private _tickId:any = -1;
	private _count:number = 0;
	private _startDelay:number = 1;
	private _repeatCount:number = 0;
	private _delay:number = 0;
	private _fn:Function|null = null;

	private reset(){
		this._count = -1;
		if(this._startId){ clearTimeout(this._startId); }
		if(this._tickId){ clearTimeout(this._tickId); }
		this._startId = null;
		this._tickId = null;
	}

	private tick(){
		if(this._fn){ this._fn(); }
		this._count++;
		this._tickId = null;
		if(this._count < this._repeatCount){
			this._tickId = setTimeout(() => this.tick(), this._delay);
		}
	}
}